export default __webpack_public_path__ + "static/media/books-image.6b1688db.webp";